import React from 'react'

function DatePickerContainer({
  label,
  info,
  value,
  onDateChange,
  error,
  formKey,
}) {
  return (
    <wb-input-control>
      <wb-input>
        <label>{label}</label>
        <input
          type="date"
          value={value}
          onChange={(event) => {
            event.preventDefault()
            onDateChange({ event, formKey })
          }}
        />
      </wb-input>

      {info && info.length && (
        <wb-control-hint className="wb-padding-start-xs">
          {info}
        </wb-control-hint>
      )}
      {error && error.length && <wb-control-error>{error}</wb-control-error>}
    </wb-input-control>
  )
}

export default DatePickerContainer
